import { render, staticRenderFns } from "./MostCommonRosterBox.vue?vue&type=template&id=73c312c2&scoped=true"
import script from "./MostCommonRosterBox.vue?vue&type=script&lang=js"
export * from "./MostCommonRosterBox.vue?vue&type=script&lang=js"
import style0 from "./MostCommonRosterBox.vue?vue&type=style&index=0&id=73c312c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c312c2",
  null
  
)

export default component.exports